<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn color="primary" x-small text @click="goBack">
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Meus Pontos
          <e-help-tooltip
            text="Consulte suas batidas de ponto registradas no PontoFiq por dia, últimos 10 dias ou período, com acesso aos comprovantes e ao espelho de ponto."
          />
        </h1>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card outlined>
          <v-card-text>
            <horario-tabs v-model="tab" class="mb-4" />

            <div v-if="tab === 0">
              <horario-dia-filtro v-model="dataSelecionada" class="mb-3" @buscar="buscarDia" />
              <horario-lista-agrupada :registros="registrosDia" comprovante-service="colaborador" />
            </div>

            <div v-if="tab === 1">
              <v-btn color="primary" class="mb-3" @click="buscarUltimos10Dias">
                <v-icon left small>mdi-refresh</v-icon>
                Atualizar
              </v-btn>
              <horario-lista-agrupada
                :registros="registrosUltimos10Dias"
                comprovante-service="colaborador"
              />
            </div>

            <div v-if="tab === 2">
              <horario-periodo-filtro
                v-model="periodo"
                class="mb-3"
                @buscar="buscarPeriodo"
                @gerar-pdf="gerarPdfPeriodo"
              />
              <horario-lista-agrupada
                :registros="registrosPeriodo"
                comprovante-service="colaborador"
              />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <e-modal-espelho-ponto-pdf
      :dialog="dialogPdf"
      :pdf="pdf"
      title="Espelho de Ponto"
      @close="fecharPdf"
    />
  </main-template>
</template>

<script>
import HorarioTabs from "@/components/Instrutores/HorarioTabs.vue";
import HorarioDiaFiltro from "@/components/Instrutores/HorarioDiaFiltro.vue";
import HorarioPeriodoFiltro from "@/components/Instrutores/HorarioPeriodoFiltro.vue";
import HorarioListaAgrupada from "@/components/Instrutores/HorarioListaAgrupada.vue";
import EModalEspelhoPontoPdf from "@/components/Instrutores/EModalEspelhoPontoPdf.vue";

const hoje = () => new Date().toISOString().slice(0, 10);

export default {
  name: "MeusPontosPage",
  components: {
    HorarioTabs,
    HorarioDiaFiltro,
    HorarioPeriodoFiltro,
    HorarioListaAgrupada,
    EModalEspelhoPontoPdf,
  },
  data() {
    return {
      tab: 0,
      dataSelecionada: hoje(),
      periodo: [],
      registrosDia: [],
      registrosUltimos10Dias: {},
      registrosPeriodo: {},
      dialogPdf: false,
      pdf: null,
    };
  },
  watch: {
    tab(value) {
      if (value === 1 && Object.keys(this.registrosUltimos10Dias).length === 0) {
        this.buscarUltimos10Dias();
      }
    },
  },
  mounted() {
    this.buscarDia();
    this.buscarUltimos10Dias();
  },
  beforeDestroy() {
    this.limparPdfAtual();
  },
  methods: {
    goBack() {
      this.$goBack();
    },
    async buscarDia() {
      try {
        this.$loaderService.open("Carregando pontos");
        this.registrosDia = await this.$services.colaboradorPontosService.meusPontosDia({
          data: this.dataSelecionada,
        });
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async buscarUltimos10Dias() {
      try {
        this.registrosUltimos10Dias =
          await this.$services.colaboradorPontosService.meusPontosUltimos10Dias();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async buscarPeriodo(form) {
      try {
        this.$loaderService.open("Carregando período");
        this.registrosPeriodo = await this.$services.colaboradorPontosService.meusPontosPeriodo(
          form
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async gerarPdfPeriodo(form) {
      try {
        this.$loaderService.open("Gerando espelho de ponto");
        this.limparPdfAtual();
        this.pdf = await this.$services.colaboradorPontosService.meusPontosPeriodoPdf(form);
        this.dialogPdf = true;
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    fecharPdf() {
      this.dialogPdf = false;
      this.limparPdfAtual();
    },
    limparPdfAtual() {
      if (this.pdf) {
        window.URL.revokeObjectURL(this.pdf);
        this.pdf = null;
      }
    },
  },
};
</script>
